import {
    Button,
    Grid2,
    Paper,
    styled,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import React from 'react';
import { useGetOpenOrders } from 'hooks/useGetOpenOrders';
import dayjs from 'dayjs';
import { AccountSelector } from 'components/AccountSelector/AccountSelector';
import { useGetFleetUserAccounts } from 'hooks/useGetFleetUserAccounts';
import { InvoicePopup } from 'components/InvoicePopup/InvoicePopup';
import { NoResultsRow } from 'components/NoResultsRow/NoResultsRow';

const HeaderCell = styled(TableCell)(() => ({
    fontWeight: 'bold',
    backgroundColor: '#F5F5F5',
}));

export function OpenOrders() {
    const accounts = useGetFleetUserAccounts();
    const [selectedAccount, setSelectedAccount] = React.useState<string>('none');
    const [selectedInvoice, setSelectedInvoice] = React.useState<string | undefined>(undefined);
    const orders = useGetOpenOrders(selectedAccount);

    return (
        <Grid2 container spacing={2} style={{ padding: '0 24px', marginTop: 32 }}>
            <Grid2 size={{ xs: 12, md: 4 }}>
                <AccountSelector
                    label="Filter by Location"
                    value={selectedAccount}
                    onChange={setSelectedAccount}
                    accounts={accounts.data || []}
                    noSelectionText="All Locations"
                    labelField="customerName"
                />
            </Grid2>
            <TableContainer component={Paper} style={{ marginBottom: 24 }}>
                <Table sx={{ minWidth: 700 }} size="small" aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <HeaderCell>Order Type</HeaderCell>
                            <HeaderCell>Work Order #</HeaderCell>
                            <HeaderCell>Account #</HeaderCell>
                            <HeaderCell>Name</HeaderCell>
                            <HeaderCell>Address</HeaderCell>
                            <HeaderCell>City/State</HeaderCell>
                            <HeaderCell>Zip</HeaderCell>
                            <HeaderCell>Date</HeaderCell>
                            <HeaderCell style={{ width: 75 }}>Actions</HeaderCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(orders.isLoading || accounts.isLoading) && <NoResultsRow colSpan={8} text="Loading..." />}
                        {!orders.isLoading && orders.data?.length === 0 && (
                            <NoResultsRow colSpan={8} text="No records found" />
                        )}
                        {(orders.data || []).map((order) => (
                            <TableRow key={order.id}>
                                <TableCell>{order.orderType}</TableCell>
                                <TableCell>TCX{order.id}</TableCell>
                                <TableCell>{order.mcsnAcctnum}</TableCell>
                                <TableCell>{order.customerName}</TableCell>
                                <TableCell>{order.customerAddress}</TableCell>
                                <TableCell>
                                    {order.customerCity}, {order.customerState}
                                </TableCell>
                                <TableCell>{order.customerZip}</TableCell>
                                <TableCell>{dayjs(order.orderDate).format('MM/DD/YYYY')}</TableCell>
                                <TableCell>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={() => {
                                            setSelectedInvoice(order.id.toString());
                                        }}
                                    >
                                        View
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <InvoicePopup invoiceId={selectedInvoice} setInvoiceId={setSelectedInvoice} />
        </Grid2>
    );
}
